const DIAS_SEMANA = ["DOMINGO", "SEGUNDA-FEIRA", "TERCA-FEIRA", "QUARTA-FEIRA", "QUINTA-FEIRA", "SEXTA-FEIRA", "SABADO"];

// Compara sem acento: o cadastro tem "Sabado" e "Sábado" misturados.
export const normalizarDia = (texto) =>
  texto?.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase().trim();

const paraMinutos = (hhmm) => {
  const [h, m] = String(hhmm || "").split(":").map(Number);
  return Number.isFinite(h) ? h * 60 + (Number.isFinite(m) ? m : 0) : null;
};

const horarioDoDia = (operatingHours, indiceDia) =>
  operatingHours.find((h) => normalizarDia(h.diaSemana) === DIAS_SEMANA[(indiceDia + 7) % 7]);

// Situação do restaurante agora. Considera expediente que passa da meia-noite
// (ex.: segunda 18:00–02:00 continua aberto na terça à 01:00).
// Retorna null quando não há horário cadastrado.
export const situacaoFuncionamento = (operatingHours, agora = new Date()) => {
  if (!operatingHours || operatingHours.length === 0) return null;

  const minutos = agora.getHours() * 60 + agora.getMinutes();
  const diaHoje = agora.getDay();
  const hoje = horarioDoDia(operatingHours, diaHoje);
  const ontem = horarioDoDia(operatingHours, diaHoje - 1);

  if (ontem) {
    const abertura = paraMinutos(ontem.horarioAbertura);
    const fechamento = paraMinutos(ontem.horarioFechamento);
    if (abertura != null && fechamento != null && fechamento < abertura && minutos <= fechamento) {
      return { aberto: true, horarioHoje: hoje || null };
    }
  }

  if (!hoje) return { aberto: false, horarioHoje: null };

  const abertura = paraMinutos(hoje.horarioAbertura);
  const fechamento = paraMinutos(hoje.horarioFechamento);
  if (abertura == null || fechamento == null) return { aberto: false, horarioHoje: hoje };

  const aberto = fechamento < abertura
    ? minutos >= abertura // vira a noite: a parte depois da meia-noite é tratada como "ontem" no dia seguinte
    : minutos >= abertura && minutos <= fechamento;
  return { aberto, horarioHoje: hoje };
};
